module.exports = __webpack_public_path__ + "img/map-coming-soon.1df77555.png";